export const LEARNING_MENU_TYPE = 'EDUAURAA';
export const ILT20_TOP_CATEGORY_NAME = 'Sports ILT20';
export const LOGIN_TEXT = 'LOGIN';
export const WELCOME_TEXT = 'Welcome';
export const RUPEE_SYMBOL = '₹';
export const DOLLAR_SYMBOL = '$';
export const PERCENT_SYMBOL = '%';
export const SINGLE_SPACE = ' ';
export const EMPTY_STRING = '';
export const ENTER_CODE = 'Enter code';
export const GUEST = 'Guest';
export const EVENT_NAME = 'eventName';
export const SEARCH_LANDING = 'Search Landing';
export const EXPLORE_MORE = 'Explore More';
export const LANDING_ON_SUBSCRIBER_PLANS_SCREEN =
  'landing_on_subscriber_plans_screen';
export const APPSFLYER_CONSTANTS = {
  EVENT: 'EVENT',
  EVENT_TYPE: 'eventType',
  EVENT_NAME: 'eventName',
  EVENT_REVENUE: 'eventRevenue',
  EVENT_REVENUE_CURRENCY: 'eventRevenueCurrency',
  EVENT_VALUE: 'eventValue',
  LANDING_ON_SUBSCRIBER_PLANS_SCREEN: 'landing_on_subscriber_plans_screen',
  AF_ADD_TO_CART: 'af_add_to_cart',
  LANDING_ON_PAYMENT_SCREEN: 'landing_on_payment_screen',
  AF_INITIATED_CHECKOUT: 'af_initiated_checkout',
  AF_PURCHASE: 'af_purchase'
};
export const New_CC_Campaign_AVOD_Message =
  '10% OFF on Credit Card, on {{currency}}{{price}}/{{duration}} plan';
export const LOGIN_REQUIRED = 'Login Required';

export const SUBSCRIPTION_PAGE_HEADER =
  'Avail the Best ZEE5 Subscription Plan & ZEE5 Offers';
export const SUBSCRIPTION_PAGE_DESCRIPTION =
  'Get ZEE5 premium subscription to watch latest episodes premiere before TV. Buy ZEE5 OTT subscription with best offers to watch TV Shows, ZEE5 Originals, Movies, Live TV Channels & more.';
export const SUBSCRIPTION_PAGE_HEADER_GLOBAL =
  'ZEE5 Subscription | Enjoy ZEE5 ad-free with multiple subscription plans';
export const SUBSCRIPTION_PAGE_DESCRIPTION_GLOBAL =
  'ZEE5 Plan - Enjoy all your favorite TV shows, the latest originals, movies and much more, ad-free, anytime, anywhere. Get the ultimate South Asian entertainment with a ZEE5 Premium membership.';
export const GUEST_USER_X_TOKEN = 'GUEST_USER_X_TOKEN';
export const ZEE5 = 'ZEE5';
export const CLP = 'CLP';
export const IN = 'in';
export const MOBILE_LOGIN = 'Mobile Login';
export const LOGIN = 'login';
export const CANCEL_SUBSCRIPTION = 'Cancel Subscription';
export const BROWSE_ALL_PACK = 'Browse All Packs';
export const EDIT = 'edit';
export const VERIFY_MOBILE = 'Please verify your Mobile number via OTP';
export const VERIFY_EMAIL = 'Please verify your Email via OTP';
export const ENTER_USERNAME = 'Enter Email ID OR Mobile Number';
export const TO = 'To';
export const NO_AUTO_SUGGEST_RECORD_TOP = "0 search result for '{ZEE5}'.";
export const EXPIRING_IN = 'Expiring in';
export const OTHER_PLAN = 'Please select any other plan with higher price';
export const RENEWING_IN = 'Renewing in';
export const SHOW_EPISODES = 'Show Episodes';
export const DOB_SELECT = 'Please select Date of Birth';
export const GENDER_SELECT = 'Please select a gender';
export const MOBILE_SMS_MESSAGE = 'SMS successfully sent';
export const CONNECTED_WITH = 'Connected with';
export const LOGIN_TO_CONTINUE = 'Please login to your account to continue';
export const MY_NFT = 'My NFT';
export const YES = 'Yes';
export const NO = 'No';
export const OR = 'or';
export const WATCH_FIRST_EPISODE = 'Watch First Episode';
export const SESSION_EXPIRED_MESSAGE =
  'Your session has expired. Please login to continue';
export const PASSWORD_RESET_MESSAGE_EMAIL =
  'Your password reset link will be emailed to you';
export const PASSWORD_RESET_MESSAGE_MOBILE =
  'We will send an OTP(One Time Password) to your mobile';
export const SET_NEW_PASSWORD = 'Set New Password';
export const CREATE_NEW_PASSWORD = 'Create New Password';
export const CREATE_PASSWORD = 'Create Password';
export const CREATE_A_NEW_ACCOUNT = 'Create a new account';
export const REGISTER_SUBHEAD =
  'Create a account to continue enjoying uninterrupted video and personalised experience';
export const VERIFY_MOBILE_SET_PASSWORD_MESSAGE =
  'An verification OTP (One Time Password) has been sent to the registered mobile number {{number}}. Verify mobile to set password';
export const ACCOUNT_ALREADY_EXISTS_MOBILE_NUMBER =
  'This Phone number used already by some other user';
export const SAMSUNG_LOGIN_ERROR = 'Samsung Registration Failed!';
export const START_FREE_TRIAL = 'Start Free Trial';
export const No_EXPIRED_PLANS = 'You don’t have any plan history';
export const EXPIRED_PLAN = 'Expired Plans';
export const REGISTER_PROCEED_TEXT = 'By proceeding you agree to our ';
export const TERMS_OF_SERVICES = 'Terms Of Services ';
export const PRIVACY_POLICY = ' Privacy Policy';
export const ALREADY_SUBSCRIBED = 'Already Subscribed';
export const FIRSTNAME = 'First Name';
export const LASTNAME = 'Last Name';
export const FULLNAME = 'Full Name';
export const YOUR_FULL_NAME = 'Your full name';
export const AGE = 'Your Age';
export const Email = 'Email Id';
export const DATE_OF_BIRTH = 'DD/MM/YYYY';
export const USER_EXISTS = 'This user already exists';
export const WHY_REGISTER = 'Why Register ?';
export const VERIFICATION_MESSAGE_SENT =
  'An verification OTP ( one time password) has been sent to the mobile number {{number}} . Verify mobile to complete profile update.';
export const UPDATING_DETAILS = 'Updating Details…';
export const OPEN_IN_CHROME_MSG =
  'For better viewing experience, open site in chrome browser';
export const ADD_TO_HOME_SCREEN_IMG_ALT = 'Add to home screen';
export const LIVE = 'LIVE';
export const LIVE_CAPITALIZATION = 'Live';
export const LIVE_SMALLCASE = 'live';
export const LIVE_TV = 'live-tv';
export const MOVIES = 'movie';
export const TVSHOW = 'tvshow';
export const NOEVENT = 'noEvent';
export const UPGRADE = 'UPGRADE';
export const ZERO_STRING = 'ZERO';
export const REASON_POPUP_STRINGS = {
  REASON_FOR_CANCELLATION: 'Mention reason of Cancelation',
  I_DINT_LIKE_CONTENT: 'I did not like Content',
  UNABLE_TO_VIEW_PREMIUM: 'I am unable to view premium content',
  I_DONT_WATCH_PREMIUM: 'I dont watch premium content anymore',
  I_FIND_SUBSCRIPTION_EXPENSIVE: 'I find subscription plans expensive',
  OTHERS: 'Others'
};
export const EXIT = 'Exit';
export const CONSENT_SETTING = 'Consent Settings';
export const ISRELOAD = 'isreload';
export const PRIVACY_NOTICE = 'Privacy Notice';
export const SUBSCRIPTION_START = 'subscription_start';
export const FREE_TRIAL = 'Free Trial';
export const H1_TAG_TITLE = {
  ORIGINAL_WEB_SERIES_AND_MOVIES: 'Web Series',
  TV_SHOWS: 'TV Shows',
  MOVIES: 'Movies',
  LIVE_TV_CHANNELS: 'Live TV Channels',
  ZEE5_PREMIUM: 'ZEE5 Premium',
  CLUB_PACK: 'Club Pack',
  PLAY5_GAMES: 'Play5 Games',
  KIDS_SHOWS_AND_MOVIES: 'Kids Shows and Movies',
  VIDEOS_AND_TRAILERS: 'Videos & Trailers',
  HIPI: 'HiPi',
  CHANNEL_GUIDE: 'TV Channel Guide',
  SUBSCRIPTION: 'Zee5 Premium Subscription',
  EDUAURAA: 'Eduauraa Learning Platform',
  IL_T20: 'ILT20 2023',
  ILT20: 'ILT20',
  VIEW_FULL_SCHEDULE: 'View Full Schedule',
  ILT20_SCHEDULE: 'ILT20 2023 Schedule, Live Scores & Results',
  ALL_EPISODE: 'All Episodes'
};
export const LOGIN_PAGE = {
  REGISTER_CREATEACCOUNTENJOYVIDEO:
    'Login to continue enjoying uninterrupted videos and personalised experience',
  VERIFY_MOBILE_NUMBER: 'Verify your Mobile Number'
};
export const LOGIN_TO_ZEE5 = 'Login to ZEE5';
export const LOGIN_SUB_HEAD =
  'Login to continue enjoying uninterrupted video and personalised experience';
export const REGISTERED_SUSSESS = 'Registered Successfully!';
export const GLOBALREASONSUCCESSTITLE = 'Your membership is now cancelled';
export const GLOBALREASONSUCCESSTEXT =
  'We would love to have you back.If you change your mind,simply restart your membership';
export const GLOBALREASONSUCCESSBUTTON = 'Continue to ZEE5';
export const USER_TYPE_GUEST = 'guest';
export const USER_TYPE_REGISTER = 'register';
export const COMBO_OFFER_WIDGET = {
  TITLE: 'Buy Combo offer',
  PRICE_PREPOSITION: 'for',
  KNOW_MORE: 'know more'
};
export const MANDATORY_REGISTRATION_POPUP_CONFIG = 3;
export const SET_SELECTION_RANGE = 'setSelectionRange';
export const SELECTION_START = 'selectionStart';
export const SELECTION_END = 'selectionEnd';
export const DEVICE_AUTH_CHAR_LENGTH = 6;
export const FIELD_NAME = {
  USER_NAME: 'userName',
  FULL_NAME: 'fullName',
  EMAIL: 'email',
  PHONE: 'phone',
  USER_MOBILE: 'userMobile',
  AGE: 'age',
  MOBILE: 'mobile'
};
export const AUTOCOMPLETE_FIELD = {
  AUTOFILL_EMAIL: 'email',
  AUTOFILL_NAME: 'name',
  AUTOFILL_NUM: 'tel'
};
export const BROWSE_BY_GENRE = 'Browse by Genre';
export const BROWSE_BY_LANGUAGE = 'Browse by Language';
export const LIVE_CHANNELS = 'Live Channels';
export const AMAZON_VOUCHER_CONSTANTS = {
  HEADER_TEXT: 'Amazon Pay Gift Card Details',
  VOUCHER_AMOUNT: 'Voucher Amount',
  VOUCHER_NUMBER: 'Voucher No.',
  VOUCHER_PIN: 'Voucher PIN',
  VOUCHER_EXPIRYDATE: 'Expiry Date'
};
export const EDUAURAA = 'Eduauraa';
export const PREBOOK = 'prebook';
export const BUYPLAN = 'buyplan';
export const FILTERCOLLECTIONID = '0-8-3z5100279';
export const QUERY = 'query';
export const SEARCH = 'search';
export const LIVETV = 'liveTv';
export const FORENSICMOVIEID = '0-0-1z5149852';
export const HOME_RECO_EXPERIMENT_NAME = 'AB Testing Bucketing';
export const HP_RECCOVSCMS_EXPERIMENT_NAME = 'HP_ReccoVsCMS';
export const CUSTOM_FEATURING_EXPERIMENT_NAME = 'Custom Featuring';
export const VARIANT_ON = 'HP_Control_CMS';
export const VARIANT_OFF = 'OFF';
export const JANHIT_MEIN_JAARI_MOVIE_ID = '0-0-1z5177236';
export const WATCH_SEASON_3_HERE = 'Watch Season 3 here';
export const RANGBAAZ_URL =
  '/web-series/details/rangbaaz-darr-ki-rajneeti/0-6-4z5173774';
export const RANGBAAZ_TAMIL_URL =
  '/web-series/details/rangbaaz-darr-ki-rajneeti-tamil/0-6-4z5176940';
export const RANGBAAZ_TELUGU_URL =
  '/web-series/details/rangbaaz-darr-ki-rajneeti-telugu/0-6-4z5176942';
export const ABTesting = {
  RANDOMIZER: 'RANDOMIZER',
  CUSTOM_FEATURING: 'CUSTOM_FEATURING',
  HOME_RECOMMENDATION: 'HOME_RECOMMENDATION',
  TOP_SEARCH: 'TOP_SEARCH',
  HP_RECCOVSCMS: 'HP_ReccoVsCMS'
};
export const HOME_RECO_COLLECTION_ID = '0-8-homepage-test';
export const RANGBAAZ_DARR_KI_RAJNEETI = '0-6-4z5173774';
export const Z5_PLANS_SYSTEM = 'Z5';
export const ZEE5_PLANS_SYSTEM = 'ZEE5';
export const B2B_CLP_SYSTEM = 'B2B_CLP';
export const MUKHBIR_THE_STORY_OF_A_SPY = '0-6-4z5199975';
export const KHUDA_HAAFIZ_CHAPTER_2_AGNI_PARIKSHA = '0-0-1z5206274';
export const RASHTRA_KAVACH_OM = '0-0-1z5191648';
export const DURANGA_COLLECTION_ID = '0-6-4z5193948';
export const TOP_SEARCH_EXPERIMENT_NAME = 'Top_Search_Exp';
export const ILT20_POINTS_TABLE = 'ILT20 Points Table';
export const WATCH_NOW = 'Watch Now';
export const WATCH_HIGHLIGHTS = 'Watch Highlights';
export const COMPLETED = 'completed';
export const EXTRAS = 'Extras';
export const ILT20_SERIES = 'Cricket-ILT20';
export const ILT_GRID_LIST = {
  POINTS: 'points',
  HEADER: 'Header',
  BATTING_TABLE: 'battingTable',
  BOWLING_TABLE: 'bowlingTable',
  YET_TO_BAT: 'YetToBat',
  FIRST_INNINGS: '1st Innings',
  SECOND_INNINGS: '2nd Innings',
  POINTS_HEADER: 'PointsHeader',
  TOURNAMENT_SCHEDULE: 'tournamentSchedule',
  TOURNAMENT_TEAMS: 'tournamentTeams',
  LEADERBOARD: 'leaderboard',
  CONTENT_SHARE: 'Share',
  HOW_TO_PLAY_GUIDE: 'howToPlayGuideOutline',
  REGISTER_OUTLINE: 'registerOutline',
  LEADERBOARD_REWARD: 'leaderBoardReward'
};
export const ILT_MENU_TOOL_TIP_MESSAGE = "Discover what's new in ILT20";
export const ILT20_CONSUMPTION_PAGE = 'ILT20 ConsumptionPage';
export const ILT20_SCORE_TABLE = 'ILT20 Score board';
export const WEB_DEVICE_VIDEO_CODEC = 'H.264';
export const WEB_DEVICE_CHROME_AUDIO_TECHNOLOGY = 'Stereo';
export const WEB_DEVICE_SAFARI_AUDIO_TECHNOLOGY =
  'Stereo, Dolby Atmos, Dolby Digital Plus, Dolby Digital';
export const WEB_DEVICE_VIDEO_RANGE = 'SDR';
export const SPORTS_LANDING_PAGE = 'sports';
export const TEAMDETAIL_SQUAD = 'teamdetails-squad';
export const TEAMDETAIL_SCHEDULE = 'teamdetails-matchschedule';
export const TEAMDETAIL_VIDEOS = 'teamdetails-videos';
export const SPORTS_VOD = 'sports-VOD';
export const PROMO_100_PERCENT_OFF_SUCCESS_MSG =
  'Congratulations! You’re just a step away from your free trial. Enter your card details to unlock the offer!';
export const LIVE_CRICKET = 'livecricket';
export const REWARDS = 'Rewards';
export const LEADERBOARD = 'Leaderboard';
export const LIVE_CONSUMPTION_SCOREBOARD = 'consumption-scoreboard';
export const LIVE_CONSUMPTION_KEYMOMENTS = 'consumption-keymoments';
export const ILT_MATCH_SCHEDULE = 'matchschedule';
export const NO_VIDEO_FALL_BACK_TEXT =
  ' Videos for this team will be available soon.';
export const LINK_COPIED = 'Link copied to share';
export const UNABLE_TO_PROCESS_API_REQUEST =
  'We are unable to process your request at this time. Please try again later.';
export const VERIFY_MOBILE_NUMBER = 'verify-mobile-number';
export const ADD_WATCHLIST = 'Add to watchlist';
export const REMOVE_WATCHLIST = 'Remove from watchlist';
export const LIVE_EVENT = 'live_event';
export const MATCH_CLIPS = 'match-clips';
export const VIEW_ALL = 'view_all';
export const TURN_OFF_VPN = 'Please turn off your VPN and try again';
export const CONTENT_LIKE = 'Content Liked';
export const CONTENT_DISLIKE = 'Content Disliked';
export const LIKE_TOGGLE_ON = 'On';
export const LIKE_TOGGLE_OFF = 'Off';
export const TOKEN_EXPIRED = 'Token Expired';
export const GQL = 'GQL';
export const GQL_FAILED_ERROR = 'GQL_FAILED_ERROR';

export enum VI_BLOCKER_SCREEN {
  Vi_Blocker_Text1 = 'Watch ZEE5 at NO EXTRA COST*!',
  Vi_Blocker_Text2 = 'Launch from',
  Vi_Blocker_Text3 = 'Vi Movies & TV App',
  Vi_Blocker_CTA = 'Launch Vi Movies & TV',
  Vi_Blocker_Existing_User = 'Existing ZEE5 user? Click here to login',
  Vi_Blocker_Footer = '*With VIP and Classic access of Vi Movies and TV',
  Vi_Back_To_Vi_CTA = 'Back to Vi Movies & TV'
}

export enum PartnerPlatforms {
  TATASKY_PARTNER = 'tatasky',
  VIMTVAPP = 'ViMTVApp',
  VIMTV = 'Vimtv',
  VIMTV_ANDROID = 'vimtv_android',
  TATASKY = 'tataskybinge',
  SAMSUNG_MY_GALAXY_APP = 'samsungmygalaxyapp'
}

export enum PartnerPlatformIds {
  VIMTVID = 116,
  VIAPP = 10,
  VIAPP_PT = 136
}

export enum HeaderElements {
  TV_CHANNEL = 'tv-channels',
  TV_SHOW = 'tv-shows',
  LOGIN = 'Login'
}

export enum SubscriptionComponentImageAlt {
  TICK = 'tick',
  CROSS = 'cross',
  CODE_APPLIED_ICON = 'code applied icon',
  APPLY_CODE_ICON = 'apply code icon',
  ARROW = 'arrow',
  PAYMENT_ICON = 'paymentIcon'
}

export const FOOTER_URLS_CONSTANTS = {
  TV_SHOWS: 'tv-shows',
  MOVIES: 'movies',
  WEB_SERIES: 'web-series',
  ORIGINALS: 'originals',
  EPISODES: 'episodes',
  SERIES: 'series',
  KIDS: '/kids',
  KIDS_SHOWS: 'kids-shows',
  KID: 'kids'
};
export const SETTINGS = 'settings';
export const RECENT_MAX_SEARCH_LENGTH = 5;
export const NEW_RECENT_MAX_SEARCH_LENGTH = 10;

export const SEO_CONTENT = {
  TOURNAMENT_NAME: 'Tournament Name',
  START_DATE: 'Start Date',
  END_DATE: 'End Date',
  VENUE: 'Venue',
  FORMAT: 'Format',
  FIRST_EDITION: 'First Edition',
  LATEST_EDITION: 'Latest Edition',
  NEXT_EDITION: 'Next Edition',
  NO_TEAMS: 'Number of teams',
  AUDIO_LANGUAGE: 'Audio Language: ',
  AUDIO_LANGUAGES: 'Audio Languages: ',
  MOVIE_DURATION: 'Total Movie Duration: ',
  EPISODE_DURATION: 'Total Episode Duration: ',
  KEY_POINTS: 'Keypoints about',
  GENRES: 'Genres',
  GENRE: 'Genre',
  NAME: 'Name',
  DIRECTORS: 'Director',
  CAST: 'Cast'
};

export enum DisplayLanguage {
  ENGLISH = 'en',
  TAMIL = 'ta',
  KANNADA = 'kn',
  MALAYALAM = 'ml',
  HINDI = 'hi',
  GERMAN = 'de',
  RUSSIAN = 'ru'
}

export const DefaultContentLanguages = `${DisplayLanguage.ENGLISH},${DisplayLanguage.HINDI}`;

export enum HeaderComponentImageAlt {
  ZEE5_LOGO = 'ZEE5 Logo',
  BACK = 'Back',
  USER_LOGO = 'Zee5 User logo'
}

export enum HeaderImageUrl {
  ZEE5_LOGO_URL = '/webapp-assets/images/ZEE5_logo.svg',
  ZEE5_BACK_BUTTON = '/webapp-assets/images/back_arrow_subs.svg',
  USER_LOGO_URL = '/webapp-assets/images/User.svg'
}
export enum HamburgerMenuUrls {
  ZEE5_LOGO = '/webapp-assets/images/ZEE5_logo.svg',
  HAMBURGERMENU_ICON = '/webapp-assets/images/hamburger_icon.svg',
  CHEVRON_ICON = '/webapp-assets/images/chevron.svg'
}

export enum consumptionPageUrls {
  COPY_LINK_URL = '/webapp-assets/images/copy_link.svg'
}

export enum HamburgerMenuAlt {
  ZEE5_LOGO = 'Zee5 logo',
  HAMBURGERMENU_ICON = 'Menu',
  CHEVRON_ICON = 'Dropdown'
}

export enum SubscriptionComponentImagePaths {
  CODE_APPLIED_ICON_IMAGE = '/webapp-assets/images/percentage.svg',
  COHORT_INFO_ICON_IMAGE = '/webapp-assets/images/percentage-white.svg',
  APPLY_CODE_ICON_IMAGE = '/webapp-assets/images/applyCode.svg'
}

export enum LOGIN_REGISTER_TEXT {
  APPLE = 'apple',
  GOOGLE = 'google',
  FACEBOOK = 'facebook',
  TWITTER = 'twitter',
  CONTINUE_WITH_EMAIL = 'Continue with Email',
  WHATSAPP = 'whatsapp',
  PHONE = 'phone',
  EMAIL = 'email'
}

export enum LanguagesPopupEnums {
  CONTENT_LANGAUGE = 'content_language',
  DISPLAY_LANGUAGE = 'display_language'
}

//policy pages

export enum CountryCode {
  IN = 'IN',
  US = 'US',
  UK = 'UK',
  RU = 'RU',
  DE = 'DE',
  GB = 'GB',
  GLOBAL = 'global'
}
export enum StateCode {
  KA = 'KA'
}

export enum NavMenuElements {
  HOME = 'HOME',
  RENT = 'RENT',
  PREMIUM = 'PREMIUM',
  FREEMOVIES = 'FREEMOVIES',
  TVSHOWS = 'TVSHOWS',
  CRICKET = 'CRICKET',
  MOVIES = 'MOVIES',
  EDUAURAA = 'EDUAURAA',
  KIDS = 'KIDS',
  MUSIC = 'MUSIC',
  SONGS = 'SONGS',
  LIVE = 'LIVE',
  VIDEOS = 'VIDEOS',
  NEWS = 'NEWS',
  ZEEORIGINALS = 'ZEEORIGINALS',
  NAV_UPCOMING = 'NAV_UPCOMING',
  CHANNELS = 'CHANNELS',
  SPORTS = 'SPORTS',
  ADDONS = 'ADDONS'
}

export enum NavMenuItemDescription {
  HOME = 'Watch TV Shows, Originals, Movies & Live News Online',
  MOVIES = 'Watch Movies Online',
  TVSHOWS = 'Watch TV Serials & Shows Online',
  MUSIC = 'Watch Music Videos Online',
  RENT = 'Rent & Watch Movies on ZEEPLEX',
  NEWS = 'Watch Latest News & Updates',
  PREMIUM = 'ZEE5 Premium Package Subscription',
  KIDS = 'Watch Kids Shows, Cartoons. Movies & Videos Online',
  LIVE = 'Watch Live TV Channels Online',
  VIDEOS = 'Watch Official Films Videos',
  EDUAURAA = 'Digital Learning Platform for Class 6 to 12, NEET, JEE Exams'
}

export enum Share_Constant {
  SHARE_CTA_CONTENT_CONSUMPTION = 'SHARE_CTA_CONTENT_CONSUMPTION',
  COPY_LINK = 'Copy Link',
  SHARE = 'share'
}
export enum PageTypes {
  SUBSCRIPTION_PAGE = 'subscriptionPage',
  MOVIE_CONSUMPTION = 'movieConsumption',
  EPISODE_CONSUMPTION = 'episodeConsumption',
  SHOWS = 'Shows',
  CELEB = 'celeb',
  SPORTS_LANDING = 'SportsLanding',
  SHOW_CONSUMPTION = 'showConsumption',
  CONSUMPTION = 'Consumption',
  TVSHOWDETAILS = 'tvShowDetails',
  REDIRECTION_PAGE = 'redirectionPage'
}

export enum UserTypes {
  GUEST = 'guest',
  PREMIUM = 'premium',
  REGISTER = 'register'
}

export enum Languages {
  hi = 'Hindi',
  te = 'Telugu',
  en = 'English',
  ta = 'Tamil',
  mr = 'Marathi',
  kn = 'Kannada',
  ml = 'Malayalam',
  bn = 'Bengali',
  gu = 'Gujarati',
  pa = 'Punjabi',
  hr = 'Bhojpuri',
  or = 'Odia',
  ur = 'Urdu',
  th = 'Thai',
  id = 'Indonesian',
  ms = 'Malay',
  de = 'German',
  ru = 'Russian',
  ar = 'Arabic',
  af = 'Afrikaans',
  es = 'Spanish',
  no = 'Norwegian',
  fr = 'French'
}

export enum PoliciesAndTermsOfUseLinks {
  TERMS_OF_USE = '/termsofuse',
  PRIVACY_POLICY = '/privacypolicy'
}
export enum ConsumptionPageUrls {
  TVSHOWS_CONSUMPTION = 'tv-shows/details',
  CHANNELCONSUMPTION = 'live-tv',
  ZEE5ORIGINALSCONSUMPTION = 'web-series/details',
  VIDEOS_CONSUMPTION = 'videos/details',
  MUSICVIDEOS_CONSUMPTION = 'music-videos/details',
  NEWS_CONSUMPTION = 'news/details',
  MOVIES_CONSUMPTION = 'movies/details',
  KIDS_CONSUMPTION_SHOWS = 'kids/kids-shows',
  KIDS_CONSUMPTION_VIDEOS = 'kids/kids-videos',
  KIDS_CONSUMPTION_MOVIES = 'kids/kids-movies',
  SPORTS_CONSUMPTION = '/cricket/ilt20/live-streaming'
}

export enum SubscriptionPageURL {
  SUBSCRIPTION_PAGE = 'myaccount/subscription'
}

export enum COHORT_CAMPAIGN_CONSTANTS {
  LAPSER = 'LAP',
  ADVANCE_RENEWAL = 'ADV',
  MOBILE = 'MOB'
}

export const AS_ZEE5_COM = 'as.zee5.com';

export const tvodConstants = {
  tvod: 'tvod',
  tvodDownloadable: 'tvod_downloadable',
  tvodPremium: 'tvod_premium'
};

export const premiumConstants = {
  premium: 'premium',
  premiumDownloadable: 'premium_downloadable',
  tvodPremium: 'tvod_premium'
};

export const LINK_TYPE = {
  GOOGLE_LINK: 'googleLink',
  FACEBOOK_LINK: 'facebookLink',
  TWITTER_LINK: 'twitterLink',
  EMAIL_LINK: 'emailLink',
  MOBILE_LINK: 'mobilelink'
};
export enum B2BConstants {
  VIEW_DIRECTOR_CAST = 'View Director and Cast',
  VIEW_LESS = 'View less',
  VIEW_ALL = 'View All'
}

export enum COUPON_TYPE {
  FLAT = 'FLAT AMOUNT OFF',
  FREE = 'FREE',
  PERCENTAGE = '%OFF'
}

export const APP_USER = 'app_user';

export enum COUPON_CATEGORY {
  GENERIC = 'GENERIC',
  UNIQUE = 'UNIQUE'
}

export const TVOD_VALIDITY = {
  COMBO_OFFER: {
    RENTAL_VALIDITY: 48,
    WATCH_VALIDITY: 6
  },
  MOVIE: {
    RENTAL_VALIDITY: 504,
    WATCH_VALIDITY: 4
  }
};

export const PARENTAL_CONSTANTS = {
  GROUP_NR: '',
  GROUP_U: 'U',
  GROUP_A: 'A',
  GROUP_UA: 'U/A',
  MAX_LENGTH: 1,
  PAGE_TITLE: 'Parental Control',
  changesSaved: 'Changes Saved Successfully',
  incorrectPass: 'Password is incorrect. Please try again!',
  VERIFY_OTP: 'Verify OTP',
  VERIFY_MOBILE: 'Please verify your Mobile number via OTP'
};

export const CELEB_URL = '/{content_type}/celeb';
export const CELEB_PROFILE_URL = '/celebs';
export const MOVIE_BY_YEAR_URL = '/movies/year';

export const LOTTIE_SUBSCRIPTION_PATH = `${process.env.NEXT_PUBLIC_STATIC_CONTENT_BASE_ADDRESS}/animations/subscription-nudge.json`;
export enum CHROME_VERSION_POPUP_STRINGS {
  ChromeBrowserUpdate_Text = 'Choose safe viewing',
  ChromeBrowserUpdate_SubText = 'Your browser may not be secured. ',
  ChromeBrowserUpdate_SubText1 = 'Update for a safe viewing experience.',
  ChromeBrowserUpdate_CTA = 'Update Now',
  ChromeBrowserUpdate_Or = 'Or',
  ChromeBrowserUpdate_CTA_ViewInZee5 = 'View on ZEE5'
}

export enum HARDWARE_ACCELERATION_POPUP_STRINGS {
  title = 'Hardware Acceleration Required For Video Playback',
  description = 'To enable: Open Chrome Settings > System > Turn on Use hardware acceleration when available',
  primaryCTA = 'Reload'
}

export const MOVIE_SEO_MIXPANEL = {
  BROWSE_BY_LANGUAGE: 'Browse by Language',
  BROWSE_BY_GENRE: 'Browse by Genre',
  BROWSE_OF_GENRE: 'Browse of Genre',
  BROWSE_OF_LANGUAGE: 'Browse of Language'
};

export enum TvShowDetailsHandleEnums {
  TIME = 'time',
  PERCENTAGE = 'percentage',
  SOME_THING_WRONG = 'SOMETHING_WENT_WRONG'
}
export const pageNameConstants = {
  MORE: 'More'
};

export const ROUTES = {
  subscription: 'myaccount/subscription',
  payment: 'myaccount/payment'
};

export const PLATFORM_NAME_CONSTANT = {
  PLATFORM_NAME: 'web_app'
};
export enum INBUILT_DATA_TYPES {
  STRING = 'string',
  NUMBER = 'number',
  OBJECT = 'object'
}

export const SHOWS = 'Shows';

export enum VOICE_PERMISSION {
  GRANTED = 'granted',
  DENIED = 'denied',
  PERMISSION_DENIED = 'permissionDenied',
  ERROR = 'Error'
}
export const PARTNER_CONTENT_CONSTANTS = {
  PARTNER_LOGO: 'partnerLogo',
  SUBSCRIBED_PARTNER_LOGO: 'subscribedPartnerLogo',
  SUBSCRIBED: 'subscribed',
  GUEST_TITLE: 'Add-on channel for ZEE5 subscribers',
  PREMIUM_TITLE: 'Get this add-on channel now',
  AGGREGATOR_SUBSCRIPTION_SUCCESSFUL: 'Aggregator_Subscription Successful',
  AGGREGATOR_PAYMENT_PAGE: 'Aggregator_Payment Page',
  AGGREGATOR_PACK_SELECTION: 'Aggregator Pack Selection'
};

export const LAUNCH_ERROR = 'LAUNCH_ERROR';
export const ONE_TRUST_GDPR_COUNTRIES_LIST = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  'GB',
  'KE',
  'HK',
  'UY',
  'AM',
  'CN',
  'TH',
  'RP',
  'CO',
  'QA',
  'IL',
  'KW',
  'SG',
  'RU',
  'ID',
  'SA',
  'BR',
  'AD',
  'AE',
  'OM',
  'EG',
  'MY',
  'LK',
  'KR',
  'JP',
  'BB',
  'NZ',
  'KP',
  'ZA',
  'MA',
  'AL',
  'VM',
  'TR',
  'AR',
  'CA',
  'CL',
  'IS',
  'NO',
  'TW',
  'CH'
];

export const ONE_TRUST_OPT_OUT_CONTRIES = ['US', 'MX', 'AU'];

export const amaFallBack = 'Please Update the App';

export const amaFallBackText = 'Feature Not Available';

export const subscriptionExitNudge = 'Subscription Exit Nudge';

export const refSubExitNudgeImage = '/webapp-assets/images/refsubexitnudge.svg';

export enum SUBS_PAGE_STRINGS {
  BINGE_OFFER_STRING = 'Binge More Pay less. Get 50% with code: ',
  BINGE_CODE = 'BINGE'
}
export const CONSUMPTION_PAGE_WIDGET = 'consumption_page_widget';
export const CONSUMPTION_PAGE_RIBBON = 'consumption_page_ribbon';
export const CONSUMPTION_PAGE = 'consumption_page';
export const VIEW_ALL_PLANS = 'View all plans';
export const GET_PREMIUM = 'Get Premium';

export const ROBOTS_CONFIG = 'ROBOTS_CONFIG';

export enum SEQUENTIAL_TRIVIA_STRINGS {
  START_VOTING = 'Vote Now',
  CHOOSE_OPTION = 'Vote',
  SKIP_QUESTION = 'Skip Question',
  TERMS_AND_CONDITIONS = "By clicking on vote now you are agreeing to Zee5's & Terms & Conditions",
  FALLBACK_TEXT = 'Download Zee5 mobile app to participate',
  CHOOSE_OPTION_SUBTEXT = 'Please select a suitable option'
}

export enum KNOW_YOUR_TEAM_STRINGS {
  DEFAULT_SHARE_CTA = "Hi! I've been watching some exciting new content on Zee5. Check out the details here",
  DEFAULT_PARENT_TITLE = '', // This text is above button, can be left empty as it won't affect anything
  DEFAULT_PARENT_BUTTON_TEXT = 'Learn More' // We require some text on button, in case of any API fails, etc.
}
